export enum ImageAnnotatorMode {
  default = 'default',
  regularTeachSession = 'regularTeachSession',
  smartTeachSession = 'smartTeachSession',
  liveSession = 'liveSession',
  anomalyTeachSession = 'anomalyTeachSession',
}
